// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__TcqSE"};